import React, { useEffect, useState } from 'react';
import { deburr } from 'lodash';

import { calcNewSigningFooterProps } from '../NewSigningCardFooter/NewSigningCardFooterFunctions';
import PlayerCardWithFade, { PlayerCardWithFadeWidths } from 'components/PlayerCardWithFade';
import GameCardContainer from 'components/GameCardContainer';
import RestrictedContainer from 'components/RestrictedContainer';
import NewSigningHeader from '../NewSigningHeader';
import NewSigningCardFooter from '../NewSigningCardFooter';
import { ITeamMember } from '@incentivegames/ig-types/lib/interfaces/apiContracts';
import './NewSigningReveal.scss';

export const newSigningRevealConfig = {
  PRE_REVEAL_DELAY_TIME: 1500,
  POST_REVEAL_DISPLAY_TIME: 3000
};

type RevealState = 'hidden' | 'reveal' | 'revealed';

export interface INewSigningRevealProps {
  newTeamMember: ITeamMember;
  onRevealComplete: () => void;
  initialRevealState?: RevealState;
}

const NewSigningReveal: React.FC<INewSigningRevealProps> = ({ newTeamMember, onRevealComplete, initialRevealState = 'hidden' }) => {
  const [revealState, setRevealState] = useState<RevealState>(initialRevealState);

  // Delayed Revealed of New Player
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (revealState === 'hidden') setTimeout(() => setRevealState('reveal'), newSigningRevealConfig.PRE_REVEAL_DELAY_TIME);
    return () => clearTimeout(timeout);
  }, [revealState]);

  const onAnimationEnd = () => setRevealState('revealed');

  // Delayed Return to main Fives page after reveal
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (revealState === 'revealed') timeout = setTimeout(onRevealComplete, newSigningRevealConfig.POST_REVEAL_DISPLAY_TIME);
    return () => clearTimeout(timeout);
  }, [revealState, onRevealComplete]);

  const footerStyle = revealState === 'revealed' ? 'new-signing-reveal-footer--revealed' : '';

  return (
    <RestrictedContainer>
      <NewSigningHeader />
      <GameCardContainer>
        <div>
          <PlayerCardWithFade
            key="new-reveal"
            onRevealAnimationEndCallBack={onAnimationEnd}
            width={PlayerCardWithFadeWidths.oneHundredAndFifty}
            teamCode={newTeamMember.teamCode}
            name={deburr(newTeamMember.displayName)}
            revealed={false}
            startAnimation={revealState === 'reveal'}
            details={{
              team: newTeamMember.teamName,
              playerNo: newTeamMember.shirtNumber,
              position: newTeamMember.position
            }}
          />
          <NewSigningCardFooter {...calcNewSigningFooterProps(newTeamMember)} className={`new-signing-reveal-footer ${footerStyle}`} />
        </div>
      </GameCardContainer>
    </RestrictedContainer>
  );
};

export default NewSigningReveal;
